import { get, post } from '../client/client';
import { endpoint } from '../endpoint';
import type {
  LoanCreate,
  LoanListQuery,
  LoanListResponse,
  LoanPaymentCreate,
  LoanPublic,
} from '../type/loan';

export const getLoans = async (params: LoanListQuery) => {
  return await get<LoanListResponse>(endpoint.getLoans, { params });
};

/** A policy only has a few loans (one at a time), so one page of 100 holds all of them. */
const POLICY_LOANS_LIMIT = 100;

/** Every loan given on one policy, open and closed. */
export const getPolicyLoans = async (policyId: number) => {
  return getLoans({ policy_id: policyId, skip: 0, limit: POLICY_LOANS_LIMIT });
};

export const createLoan = async (payload: LoanCreate) => {
  return await post<LoanPublic, LoanCreate>(endpoint.createLoan, payload);
};

export const getLoan = async (loanId: number) => {
  return await get<LoanPublic>(endpoint.getLoan(loanId));
};

export const createLoanPayment = async (loanId: number, payload: LoanPaymentCreate) => {
  return await post<LoanPublic, LoanPaymentCreate>(endpoint.createLoanPayment(loanId), payload);
};
